/* eslint react/prop-types: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import QDialogs from 'components/QDialogs';

import { getFeatureFlags } from 'utils/featureFlags/selectors';
import * as transactionActions from 'data/transactions/actions';
import * as transactionSelectors from 'data/transactions/selectors';
import * as balancesSelectors from 'data/accountBalances/selectors';

import * as qdata from './core';

export default () => (WrappedComponent) => {

  class QData extends React.PureComponent {

    performTransactionAction = (action) => qdata.performTransactionAction (action, this.props);
    unMatchTransaction = (txn) => qdata.unMatchTransaction(txn, this.props);
    matchTransactions = (txns) => qdata.matchTransactions(txns, this.props);
    deleteTransactions = (txns) => qdata.deleteTransactions(txns, this.props);
    saveTransactions = (txns, cb) => qdata.saveTransactions(txns, cb, this.props);
    setBalanceAdjust = (accountId, date, amount) => qdata.setBalanceAdjust(accountId, date, amount, this.props);

    render() {

      const qDataProps = {
        qDataSaveTransactions: this.saveTransactions,
        qDataDeleteTransactions: this.deleteTransactions,
        qDataMatchTransactions: this.matchTransactions,
        qDataUnMatchTransaction: this.unMatchTransaction,
        qDataPerformTransactionAction: this.performTransactionAction,
        qDataSetBalanceAdjust: this.setBalanceAdjust,
      };

      // wrapped component with its props, the state from HOC and uiStateProps
      return (
        <WrappedComponent
          {...{
            ...this.props,
            ...qDataProps,
          }}
        />
      );
    }
  }

  function mapStateToProps(state) {
    return {
      txnsByAccountId: transactionSelectors.getTransactionsByAccountId(state),
      balancesByAccountId: balancesSelectors.getBalancesByAccountId(state),
      productName: getFeatureFlags(state).get('productName'),
      featureFlags: getFeatureFlags(state),
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      createTransactions: (payload, meta) => dispatch(transactionActions.createTransactions(payload, meta)),
      deleteTransactions: (payload, meta) => dispatch(transactionActions.deleteTransactions(payload, meta)),
      updateTransactions: (payload, meta) => dispatch(transactionActions.updateTransactions(payload, meta)),
      performTransactionAction: (payload, meta) => dispatch(transactionActions.performTransactionAction(payload, meta)),
      getTransactions: () => dispatch(transactionActions.getTransactions(undefined, { context: 'qdata' })),
      genericDispatch: (action) => dispatch(action),
    };
  }


  QData.propTypes = {
    createTransactions: PropTypes.func,
    updateTransactions: PropTypes.func,
    deleteTransactions: PropTypes.func,
    getTransactions: PropTypes.func,
    performTransactionAction: PropTypes.func,
    txnsByAccountId: PropTypes.object,
    balancesByAccountId: PropTypes.object,
    productName: PropTypes.string,

    // QDialog
    wrapperId: PropTypes.string,
  };

  // the HOC itself is wrapped in connect
  // return connect(mapStateToProps, mapDispatchToProps)(QData);

  return compose(
    QDialogs(),
    connect(mapStateToProps, mapDispatchToProps),
  )(QData);
};
